
import { computed, defineComponent, reactive, ref } from "vue";
import InputDate from "@/components/InputDate.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import store from "@/stores";
import { toUnixTime } from "@/lib/shared";
import {
  ContractStatus,
  ContractType,
  ErrorMessageFilter,
  IErrorResponse,
  isErrors,
  consts,
} from "@/services/Models";
import { AxiosResponse } from "axios";

export default defineComponent({
  name: "AdminContractCreate",
  components: {
    InputDate,
    ErrorMessage,
  },
  setup() {
    const resource = store.useResource();
    const router = useRouter();

    const currentDate = new Date();

    // 初期契約終了日(1週間後の同じ曜日)
    const lastDayAfter3Months = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 7
    );

    const contract = reactive({
      companyName: "",
      optionName: "",
      plan: consts.plans[2],
      signed: currentDate,
      expire: lastDayAfter3Months,
      describe: "",
      type: ContractType.Trial,
    });
    const errors = ref<IErrorResponse[]>([]);
    const errorMessages = computed(() => ({
      companyName: ErrorMessageFilter(errors.value, "CompanyName"),
      optionName: ErrorMessageFilter(errors.value, "OptionName"),
      expire: ErrorMessageFilter(errors.value, "Expire"),
    }));

    // 契約登録
    const apply = async () => {
      await resource
        .saveContract({
          id: undefined,
          companyName: contract.companyName,
          optionName: contract.optionName,
          plan: contract.plan,
          signed: toUnixTime(contract.signed),
          expire: toUnixTime(contract.expire),
          describe: contract.describe,
          users: [],
          status: ContractStatus.Enabled,
          type: contract.type,
        })
        .then(async () => {
          await router.push({ name: routeNames.AdminContract });
          errors.value = [];
        })
        .catch((ex: AxiosResponse) => {
          if (isErrors(ex.data)) {
            errors.value = ex.data as IErrorResponse[];
          } else {
            alert(consts.addContractFailure);
          }
        });
    };
    return {
      contract,
      apply,
      errorMessages,
      consts,
    };
  },
});
